module.exports = __webpack_public_path__ + "img/scale.173bd327.svg";